import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MobileCustomers from './pages/MobileCustomers';
import MobileCustomerDetail from './pages/MobileCustomerDetail';
import MobileProject from './pages/MobileProject';
import MobileCapture from './pages/MobileCapture';
import MobileReports from './pages/MobileReports';
import MobileReportView from './pages/MobileReportView';
import MobileRunWorkflow from './pages/MobileRunWorkflow';
import MobileProfile from './pages/MobileProfile';
import InstallPrompt from './InstallPrompt';

const MobileApp: React.FC = () => (
  <>
    <InstallPrompt />
    <Routes>
    <Route index element={<Navigate to="customers" replace />} />
    <Route path="customers" element={<MobileCustomers />} />
    <Route path="customers/:customerId" element={<MobileCustomerDetail />} />
    <Route path="projects/:projectId" element={<MobileProject />} />
    <Route path="projects/:projectId/capture" element={<MobileCapture />} />
    <Route path="projects/:projectId/run" element={<MobileRunWorkflow />} />
    <Route path="reports" element={<MobileReports />} />
    <Route path="reports/:reportId" element={<MobileReportView />} />
    <Route path="profile" element={<MobileProfile />} />
    <Route path="*" element={<Navigate to="customers" replace />} />
    </Routes>
  </>
);

export default MobileApp;
